<template>
    <div class="report-data-area-box">
        <div class="report-data-area" v-bind:id="canvasId"></div>
    </div>
</template>

<script>
export default {
    name: 'ReportDataArea',
    props: ['canvasId', 'xDataArr', 'yDataArr', 'levArr', 'curTimeIndex', 'clickFunc'],
    computed: {},
    data() {
        return {
            myChart: null,
            tempArr:[],
        }
    },
    watch:{
        xDataArr:{
            handler(newVal, oldVal){
                this.myChart.setOption({
                    xAxis: {
                        data: newVal,
                    }
                })
            },
            deep:true
        },
        yDataArr:{
            handler(newVal, oldVal){
                this.myChart.setOption({
                    series: [
                        {
                            data: newVal,
                        }
                    ]
                    
                })
            },
            deep:true
        },
        levArr:{
            handler(newVal, oldVal){
                let me = this;
                this.myChart.setOption({
                    series: [
                        {
                            label: {
                                show: true,
                                position: 'top',
                                offset: [0, 3],
                                formatter: function(params) {
                                    let index = params.dataIndex;
                                    let text = newVal[index].text;
                                    let color = newVal[index].color;
                                    return '{'+(index == me.curTimeIndex ? 'one|当前' : 'blank|')+'}\n'+'{'+color+'|'+text+'}';
                                },
                                rich: {
                                    one: {
                                        color: '#1F74EC',
                                        align: 'center',
                                        fontSize: 9,
                                        height: 13,
                                        backgroundColor: '#DAE9FF',
                                        borderRadius: 3,
                                        padding: [0, 2, 0, 2]
                                    },
                                    blank: {
                                        height: 13,
                                    },
                                    red: {
                                        color: '#FF6E6C',
                                        align: 'center',
                                        fontSize: 12,
                                        height: 18,
                                    },
                                    gray: {
                                        color: '#707070',
                                        align: 'center',
                                        fontSize: 12,
                                        height: 18,
                                    },
                                    blue: {
                                        color: '#1F74EC',
                                        align: 'center',
                                        fontSize: 12,
                                        height: 18,
                                    },
                                }
                            },
                            
                        }
                    ]
                }) 
            },
            deep:true
        }
    },
    mounted() {
        setTimeout(() => {
            this.tempArr = [].concat(this.yDataArr)
            this.initEcharts();
        }, 20);
    },
    methods: {
        initEcharts() {
            var me = this;
            var canvasDom = document.getElementById(this.canvasId);
            if(canvasDom == null) { return; }
            // 基于准备好的dom，初始化echarts实例
            this.myChart = this.$echarts.init(canvasDom);
            // 绘制图表
            this.myChart.setOption({
                grid: {
                    height: 100,
                    bottom: 30,
                },
                xAxis: {
                    data: me.xDataArr,
                    type: 'category',
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#F5CB70'
                        }
                    },
                    axisLabel: {
                        show: true,
                        interval: 0,
                        margin: 2, //与轴线之间距离
                        formatter: function(value, index) {
                            let arr = value.split(',');
                            // if(index == 0) {
                                // return arr[2] ? '{onee|'+arr[0]+'}\n'+'{threee|'+arr[1]+'}\n'+'{twoo|'+arr[2]+'}' : '{onee|'+arr[0]+'}\n'+'{twoo|'+arr[1]+'}';
                            // }else {
                                return arr[2] ? '{one|'+arr[0]+'}\n'+'{three|'+arr[1]+'}\n'+'{two|'+arr[2]+'}' : '{one|'+arr[0]+'}\n'+'{two|'+arr[1]+'}';
                            // }
                        },
                        rich: {
                            one: {
                                color: '#4A4A4A',
                                fontSize: 10,
                                fontWeight: 'bold',
                                height: 10,
                            },
                            onee: {
                                color: '#D99502',
                                fontSize: 10,
                                fontWeight: 'bold',
                                height: 10,
                            },
                            two: {
                                color: '#999999',
                                fontSize: 9,
                                height: 10,
                            },
                            twoo: {
                                color: '#D99502',
                                fontSize: 9,
                                height: 10,
                            },
                            three: {
                                color: '#999999',
                                fontSize: 9,
                                height: 4,
                            },
                            threee: {
                                color: '#D99502',
                                fontSize: 9,
                                height: 4,
                            },
                        }
                    },
                    axisTick: {
                        show: false
                    },
                },
                yAxis: {
                    show: false,
                    max: me.tempArr.sort((a, b) => {return b-a})[0],
                    splitNumber: 1,
                    axisLine: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    },
                },
                dataZoom: {
                    startValue: 0,
                    endValue: 5,
                    type: "inside",
                    rangeMode: "value",
                    zoomLock: true,
                },
                series: [
                    {
                        name: "Value",
                        type: "bar",
                        barWidth: 30,
                        barGap: 1,
                        data: this.yDataArr,
                        label: {
                            show: true,
                            position: 'top',
                            offset: [0, 3],
                            formatter: function(params) {
                                let index = params.dataIndex;
                                let text = me.levArr[index].text;
                                let color = me.levArr[index].color;
                                return '{'+(index == me.curTimeIndex ? 'one|当前' : 'blank|')+'}\n'+'{'+color+'|'+text+'}';
                            },
                            rich: {
                                one: {
                                    color: '#1F74EC',
                                    align: 'center',
                                    fontSize: 9,
                                    height: 13,
                                    backgroundColor: '#DAE9FF',
                                    borderRadius: 3,
                                    padding: [0, 2, 0, 2]
                                },
                                blank: {
                                    height: 13,
                                },
                                red: {
                                    color: '#FF6E6C',
                                    align: 'center',
                                    fontSize: 12,
                                    height: 18,
                                },
                                gray: {
                                    color: '#707070',
                                    align: 'center',
                                    fontSize: 12,
                                    height: 18,
                                },
                                blue: {
                                    color: '#1F74EC',
                                    align: 'center',
                                    fontSize: 12,
                                    height: 18,
                                },
                            }
                        },
                        itemStyle: {
                            formatter: function(params) {
                                console.error('itemStyle----', params)
                            },
                            color: function(params) {
                                let index = params.dataIndex;
                                let color = me.levArr[index].color;
                                if(color == 'red') {
                                    return new me.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{offset: 0, color: '#FFA7A5'}, {offset: 1, color: '#FF6E6C'}])
                                }else if(color == 'gray') {
                                    return new me.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{offset: 0, color: '#A9A9A9'}, {offset: 1, color: '#6F6F6F'}])
                                }else if(color == 'blue') {
                                    return new me.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{offset: 0, color: '#E7F1FE'}, {offset: 1, color: '#CADFFC'}])
                                }
                            },
                        },
                        emphasis: {
                            itemStyle: {
                                borderWidth: 2,
                                borderColor: '#FED070',
                                shadowColor: 'rgba(254, 234, 189, 0.5)', //RGBA(254, 234, 189, 1)
                                shadowBlur: 5,
                            }
                        }
                    }
                ],
            });
            // console.log('initEcharts------', this.canvasId, canvasDom, echarts)
            this.myChart.on('click', function (param) {  
                //param参数包含的内容有： 
                //param.name：X轴的值 
                //param.data：Y轴的值 
                //param.value：Y轴的值 
                //param.type：点击事件均为click 
                //param.seriesName：legend的名称 
                //param.seriesIndex：系列序号（series中当前图形是第几个图形第几个） 
                //param.dataIndex：数值序列（X轴上当前点是第几个点）
                let tempIndex = param.dataIndex;
                let startIndex = me.xDataArr.length-5;
                // console.log('click-----', param.dataIndex, param.seriesIndex, param.name, length)
                me.myChart.setOption({
                    xAxis: {
                        axisLabel: {
                            show: true,
                            interval: 0,
                            margin: 2, //与轴线之间距离
                            formatter: function(value, index) {
                                let arr = value.split(',');
                                // if(me.xDataArr.length > 6 && (tempIndex < startIndex && index == 0) || (tempIndex >= startIndex && index == tempIndex-startIndex+1)) {
                                //     return arr[2] ? '{onee|'+arr[0]+'}\n'+'{threee|'+arr[1]+'}\n'+'{twoo|'+arr[2]+'}' : '{onee|'+arr[0]+'}\n'+'{twoo|'+arr[1]+'}';
                                // }else if(me.xDataArr.length <= 6 && tempIndex < startIndex){
                                //     return arr[2] ? '{onee|'+arr[0]+'}\n'+'{threee|'+arr[1]+'}\n'+'{twoo|'+arr[2]+'}' : '{onee|'+arr[0]+'}\n'+'{twoo|'+arr[1]+'}';
                                // }else {
                                    return arr[2] ? '{one|'+arr[0]+'}\n'+'{three|'+arr[1]+'}\n'+'{two|'+arr[2]+'}' : '{one|'+arr[0]+'}\n'+'{two|'+arr[1]+'}';
                                // }
                            },
                            rich: {
                                one: {
                                    color: '#4A4A4A',
                                    fontSize: 10,
                                    fontWeight: 'bold',
                                    height: 10,
                                },
                                onee: {
                                    color: '#D99502',
                                    fontSize: 10,
                                    fontWeight: 'bold',
                                    height: 10,
                                },
                                two: {
                                    color: '#999999',
                                    fontSize: 9,
                                    height: 10,
                                },
                                twoo: {
                                    color: '#D99502',
                                    fontSize: 9,
                                    height: 10,
                                },
                                three: {
                                    color: '#999999',
                                    fontSize: 9,
                                    height: 4,
                                },
                                threee: {
                                    color: '#D99502',
                                    fontSize: 9,
                                    height: 4,
                                },
                            }
                        },
                        axisTick: {
                            show: false
                        },
                    },
                    dataZoom: {
                        // start: 20,
                        // end: me.canvasId == 'dataAreaMonth' ? 40 : 100,
                        startValue: tempIndex,
                        endValue: tempIndex+5,
                        type: "inside",
                        rangeMode: "value",
                        zoomLock: true,
                    },
                });
                if(me.clickFunc && typeof(me.clickFunc) == 'function') {
                    me.clickFunc({
                        index: param.dataIndex,
                        name: param.name
                    });
                }
            });
        },
    },
}
</script>